module.exports = __webpack_public_path__ + "img/success.e0a91c90.svg";